import React, { useState, useEffect } from "react";
import { FaLink } from "react-icons/fa6";
import { FaPhoneFlip } from "react-icons/fa6";
import { GrMail } from "react-icons/gr";

const PmeForm = ({ pmeForms, pmeFormsData }) => {

  const reconnaissance = [
    "Internet (Site Web, Réseaux sociaux, etc.)",
    "Au cours d’un évènement (Salon & foire, Forum, Séminaire, Panel, Atelier, etc.)",
    "Médias (Télévision, Radio, Presse écrite, affichage, etc.)",
    "A travers une connaissance",
    "Autre (à préciser)"
  ];

  const [startUpForm, setStartUpForm] = useState({
    denomination: "",
    sector: "",
    entreprise_email: "",
    ncc: "",
    nrc: "",
    entreprise_phone: "",
    address: "",
    website: "",
    reconnaissance: reconnaissance[0],
    ...pmeForms,
  });

  const handleChange = (e) => {
    setStartUpForm({
      ...startUpForm,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    pmeFormsData(startUpForm);
  }, [startUpForm]);

  return (
    <div>
      <form class=" mt-3 row g-3">
        <div class="col-md-6">
          <label for="denomination" class="form-label">
            *Dénomination
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="denomination"
              name="denomination"
              value={startUpForm.denomination}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div class="col-md-6">
          <label for="secteurActivite" class="form-label">
            *Secteur d'activité
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="secteurActivite"
              name="sector"
              value={startUpForm.sector}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div class="col-md-6">
          <label for="numeroRC" class="form-label">
            Numero de registre de commerce
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="numeroRC"
              name="nrc"
              value={startUpForm.nrc}
              onChange={handleChange}
            />
          </div>
        </div>
        <div class="col-md-6">
          <label for="numeroCC" class="form-label">
            Numero de compte contribuable
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="numeroCC"
              name="ncc"
              value={startUpForm.ncc}
              onChange={handleChange}
            />
          </div>
        </div>

        <div class="col-md-6">
          <label for="telephone" class="form-label">
            Numéro de télephone
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <FaPhoneFlip />
            <input
              type="text"
              class="form-control border-0"
              id="telephone"
              name="entreprise_phone"
              placeholder="+225xxxxxxxxxx"
              value={startUpForm.entreprise_phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div class="col-md-6">
          <label for="email" class="form-label">
            Adresse email
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <GrMail />
            <input
              type="email"
              class="form-control border-0"
              id="email"
              name="entreprise_email"
              onChange={handleChange}
              value={startUpForm.entreprise_email}
              required
            />
          </div>
        </div>

        <div class="col-md-6">
          <label for="adresse" class="form-label">
            Aresse du siège
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="adresse"
              name="address"
              value={startUpForm.address}
              onChange={handleChange}
            />
          </div>
        </div>

        <div class="col-md-6">
          <label for="siteWeb" class="form-label">
            *Site web
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <FaLink />
            <input
              type="text"
              class="form-control border-0"
              id="siteWeb"
              name="website"
              onChange={handleChange}
              value={startUpForm.website}
            />
          </div>
        </div>

        <div class="col-md-12">
          <label for="email" class="form-label">
          *Comment avez-vous connu le GUDE?
          </label>
            <select
              class="form-select form-select-lg mb-3 form-input-droit"
              aria-label="Large select example"
              name="reconnaissance"
              value={startUpForm.reconnaissance}
              onChange={handleChange}
            >
              {reconnaissance && reconnaissance.map((item) => <option value={item}>{item}</option>)}
            </select>
          </div>
      </form>
    </div>
  );
};

export default PmeForm;
